import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { whatsappHareketleri, saatlikWhatsapp } from "@/mocks/dashboard";

const CARD_BG = "#141720";
const BORDER = "#1e2130";
const TEXT_PRIMARY = "#e8eaf0";
const TEXT_SECONDARY = "#5a5f7a";

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div style={{ backgroundColor: "#1e2130", border: "1px solid #2a2d3a", borderRadius: 12, padding: "10px 14px" }}>
        <p style={{ fontSize: 11, fontWeight: 600, color: "#8b8fa8", marginBottom: 4 }}>{label}</p>
        <p style={{ fontSize: 11, color: "#22c55e" }}>Tıklama: <strong>{payload[0].value}</strong></p>
      </div>
    );
  }
  return null;
};

export default function WhatsappHareketleri() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-bold" style={{ color: TEXT_PRIMARY }}>WhatsApp Hareketleri</h2>
        <p className="text-sm mt-1" style={{ color: TEXT_SECONDARY }}>Direkt iletişime geçen kullanıcılar</p>
      </div>

      <div className="rounded-2xl p-6" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="flex items-center gap-5">
            <div className="w-16 h-16 rounded-2xl flex items-center justify-center" style={{ backgroundColor: "rgba(34,197,94,0.15)" }}>
              <i className="ri-whatsapp-line text-3xl" style={{ color: "#22c55e" }}></i>
            </div>
            <div>
              <p className="text-4xl font-bold" style={{ color: TEXT_PRIMARY }}>876</p>
              <p className="text-sm mt-1" style={{ color: TEXT_SECONDARY }}>Toplam WhatsApp Tıklaması</p>
              <span className="text-xs font-medium mt-1 px-2 py-0.5 rounded-full inline-block" style={{ backgroundColor: "rgba(34,197,94,0.15)", color: "#22c55e" }}>
                Bu kullanıcılar direkt iletişime geçti
              </span>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {[
              { label: "Bugün", deger: "47", renk: "#7c3aed" },
              { label: "Bu Hafta", deger: "312", renk: "#10b981" },
              { label: "Mobil'den", deger: "%72", renk: "#f59e0b" },
              { label: "Dönüşüm", deger: "%61.5", renk: "#22c55e" },
            ].map((item, i) => (
              <div key={i} className="text-center rounded-xl p-3" style={{ backgroundColor: "#0d0f16" }}>
                <p className="text-lg font-bold" style={{ color: item.renk }}>{item.deger}</p>
                <p className="text-xs" style={{ color: TEXT_SECONDARY }}>{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
        <div className="lg:col-span-3 rounded-2xl p-5" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
          <h3 className="text-sm font-bold mb-1" style={{ color: TEXT_PRIMARY }}>Saatlik Tıklama Dağılımı</h3>
          <p className="text-xs mb-5" style={{ color: TEXT_SECONDARY }}>Bugünkü WhatsApp tıklamaları</p>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={saatlikWhatsapp} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#1e2130" vertical={false} />
              <XAxis dataKey="saat" tick={{ fontSize: 10, fill: "#3a3d4a" }} axisLine={false} tickLine={false} interval={1} />
              <YAxis tick={{ fontSize: 11, fill: "#3a3d4a" }} axisLine={false} tickLine={false} />
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="tiklama" fill="#22c55e" radius={[4, 4, 0, 0]} opacity={0.85} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="lg:col-span-2 space-y-4">
          <div className="rounded-2xl p-4" style={{ backgroundColor: "rgba(34,197,94,0.08)", border: "1px solid rgba(34,197,94,0.2)" }}>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-7 h-7 flex items-center justify-center rounded-lg" style={{ backgroundColor: "rgba(34,197,94,0.15)" }}>
                <i className="ri-lightbulb-line text-sm" style={{ color: "#22c55e" }}></i>
              </div>
              <p className="text-sm font-bold" style={{ color: "#22c55e" }}>Akıllı Öneri</p>
            </div>
            <p className="text-sm" style={{ color: "#86efac" }}>En çok WhatsApp tıklaması <strong>"Erken Rezervasyon Fırsatı"</strong> kampanyasından geliyor. Bu kampanyayı öne çıkarın.</p>
          </div>

          <div className="rounded-2xl p-4" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
            <p className="text-sm font-bold mb-4" style={{ color: TEXT_PRIMARY }}>Kampanyaya Göre Dağılım</p>
            <div className="space-y-3">
              {[
                { kampanya: "Erken Rezervasyon", sayi: 312, yuzde: 35.6 },
                { kampanya: "Yaz Tatili Paketi", sayi: 248, yuzde: 28.3 },
                { kampanya: "Balayı Özel Paketi", sayi: 156, yuzde: 17.8 },
                { kampanya: "Aile Tatil", sayi: 98, yuzde: 11.2 },
                { kampanya: "Diğer", sayi: 62, yuzde: 7.1 },
              ].map((item, i) => (
                <div key={i}>
                  <div className="flex items-center justify-between mb-1">
                    <p className="text-xs truncate flex-1 mr-2" style={{ color: "#8b8fa8" }}>{item.kampanya}</p>
                    <div className="flex items-center gap-2 flex-shrink-0">
                      <span className="text-xs font-semibold" style={{ color: TEXT_PRIMARY }}>{item.sayi}</span>
                      <span className="text-xs" style={{ color: TEXT_SECONDARY }}>%{item.yuzde}</span>
                    </div>
                  </div>
                  <div className="h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: "#1e2130" }}>
                    <div className="h-full rounded-full" style={{ width: `${item.yuzde}%`, backgroundColor: "#22c55e" }}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="rounded-2xl overflow-hidden" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
        <div className="px-5 py-4 flex items-center justify-between" style={{ borderBottom: `1px solid ${BORDER}` }}>
          <p className="text-sm font-bold" style={{ color: TEXT_PRIMARY }}>Son WhatsApp Tıklamaları</p>
          <span className="text-xs" style={{ color: TEXT_SECONDARY }}>{whatsappHareketleri.length} kayıt</span>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr style={{ backgroundColor: "#0d0f16", borderBottom: `1px solid ${BORDER}` }}>
                {["Kullanıcı", "Kampanya", "Tıklama Zamanı", "Cihaz", "Durum"].map((h) => (
                  <th key={h} className="text-left px-5 py-3 text-xs font-semibold uppercase tracking-wide" style={{ color: TEXT_SECONDARY }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {whatsappHareketleri.map((h) => (
                <tr key={h.id} className="transition-colors" style={{ borderBottom: `1px solid ${BORDER}` }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.03)")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                >
                  <td className="px-5 py-3.5">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: "linear-gradient(135deg,#22c55e,#16a34a)" }}>
                        <span className="text-white text-xs font-bold">{h.adSoyad.split(" ").map((n) => n[0]).join("")}</span>
                      </div>
                      <p className="text-sm font-medium" style={{ color: TEXT_PRIMARY }}>{h.adSoyad}</p>
                    </div>
                  </td>
                  <td className="px-5 py-3.5">
                    <span className="text-xs font-medium px-2.5 py-1 rounded-full" style={{ backgroundColor: "rgba(34,197,94,0.15)", color: "#22c55e" }}>
                      {h.kampanya.length > 22 ? h.kampanya.substring(0, 22) + "..." : h.kampanya}
                    </span>
                  </td>
                  <td className="px-5 py-3.5">
                    <p className="text-sm" style={{ color: TEXT_PRIMARY }}>{h.saat}</p>
                    <p className="text-xs" style={{ color: TEXT_SECONDARY }}>{h.tarih}</p>
                  </td>
                  <td className="px-5 py-3.5">
                    <div className="flex items-center gap-1.5">
                      <i className={`${h.cihaz === "Mobil" ? "ri-smartphone-line" : "ri-computer-line"} text-sm`} style={{ color: TEXT_SECONDARY }}></i>
                      <span className="text-xs" style={{ color: "#8b8fa8" }}>{h.cihaz}</span>
                    </div>
                  </td>
                  <td className="px-5 py-3.5">
                    <span className="text-xs font-medium px-2.5 py-1 rounded-full" style={{ backgroundColor: "rgba(34,197,94,0.15)", color: "#22c55e" }}>{h.durum}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
